import * as types from "./actionTypes";

const initState = {
    isLoading: false,
    isAuth: false,
    isError:false
}


export const reducer = (state=initState,{type,payload}) => {
    switch (type) {
        case types.LOGIN_REQ: {
            return {
                ...state,
                isLoading: true,
                isError: false,
            }
        }
        case types.LOGIN_SUCC: {
            return {
                ...state,
                isAuth:true,
                isLoading: false,
                isError: false,
            }
        }
        case types.LOGIN_FAIL: {
            return {
                ...state,
                isLoading: false,
                isError: true,
            }
        }            
        default: return state;
    }
}